"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowDimensionsContext = void 0;

var _react = require("react");

var _WindowDimensionsContext = require("../context/WindowDimensionsContext");

var useWindowDimensionsContext = function useWindowDimensionsContext() {
  return (0, _react.useContext)(_WindowDimensionsContext.WindowDimensionsContext);
};

exports.useWindowDimensionsContext = useWindowDimensionsContext;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/hooks/useWindowDimensionsContext.js
// module id = 119
// module chunks = 209 210 211 212